import { environment } from '../../../../../../environments/environment';
import { OrderPicking } from '../../../../../core';
import { SUPERMERCADOS_CODE } from '../../../../../core/configs/company.config';
import { STATE_ORDER } from '../../../../../picking/picking-shared/enum/state-order.enum';

export const picking = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: false,
  paginator: true,
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  hasDisabledCheckBoxItem: (item: any) => {
    switch (item.state) {
      case STATE_ORDER.PICKING_PENDING:
      case STATE_ORDER.CREATED:
      case STATE_ORDER.RE_ENTRY:
        return false;

      default:
        return true;
    }
  },
  iconsOfActions: [
    {
      icon: 'picker',
      tooltip: 'Asignar pedido',
      hasVisibleCondition: (element: OrderPicking[]) => {
        const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
        return (element.filter(x => x.dispatch.pickingClient).length > 0)
          ? false : (session && session.user.entity.company.code === SUPERMERCADOS_CODE) ? false : true;
      }
    },
    {
      icon: 'cancel',
      tooltip: 'Cancelar',
      hasVisibleCondition: (element: OrderPicking[]) => {
        return element.filter(x => x.state !== STATE_ORDER.RE_ENTRY || x.hasMultipleEntitiesSelected).length > 0
          ? false
          : true;
      }
    }
  ],
  columns: [
    {
      title: 'Nota de venta',
      name: 'orderNumber',
      type: 'string',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.orderNumber
    },
    {
      title: 'N° de despacho',
      name: 'numberDispatch',
      type: 'string',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.numberDispatch
    },
    {
      title: 'N° de Pedido',
      name: 'serialNumber',
      type: 'string',
      sortServer: true,
      class: 'number-order-picking',
      value: (element: OrderPicking) => element.numberOrder
    },
    {
      title: 'Ecommerce ID',
      name: 'ecommerceId',
      type: 'string',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.ecommerceId ? element.dispatch.ecommerceId : ""
    },
    {
      title: 'Estado del despacho',
      name: 'stateOrderDispatch.name',
      type: 'string',
      class: 'center',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.state
    },
    {
      title: 'Estado del pedido',
      name: 'stateOrder.name',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: OrderPicking) => element.state
    },
    {
      title: 'Descripción SKU',
      name: 'product.description',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) =>
        element.product ? element.product.sku.concat(' - ').concat(element.product.description).replace('�', '') : ''
    },
    {
      title: 'Área',
      name: 'product.area',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) =>
        element.product ? element.product.area : ''
    },
    {
      title: 'Pickeador',
      name: 'picker.fullName',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => {
        return element.picker
          ? element.picker
            ? `${element.picker.firstName} ${element.picker.lastName}`
            : '...'
          : '...';
      }
    },
    {
      title: 'Cantidad total',
      name: 'amountTotal',
      type: 'string',
      sortServer: true,
      class: 'center',
      value: (element: OrderPicking) => element.amountTotal
    },
    {
      title: 'Cantidad solicitada',
      name: 'amountRequested',
      type: 'string',
      sortServer: true,
      class: 'center',
      value: (element: OrderPicking) => element.amountRequested
    },
    {
      title: 'Fecha de despacho',
      name: 'orderDispatch.dateDispatch',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) =>
        element.dispatch ? element.dispatch.dateDispatch : ''
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      class: 'center confirmationDispatches',
      sortServer: true,
      value: (element: OrderPicking) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      type: 'string',
      class: 'center confirmationDispatches',
      sortServer: true,
      value: (element: OrderPicking) => element.endDateDeliveryWindow
    },
    {
      title: 'Fecha y hora de creacion de despacho',
      name: 'dateDispatchCreated',
      type: 'string',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.dateDispatchCreated
    },
    {
      title: 'Fecha y hora de creacion de sku',
      name: 'dateCreated',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dateCreated
    },
    {
      title: 'Fecha y hora de inicio de picking',
      name: 'lote.dateCreated',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.lot ? element.lot.dateCreated : ""
    },
    {
      title: 'Fecha y hora de fin de picking',
      name: 'lote.finishAt',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.lot ? element.lot.finishAt : ""
    },
    {
      title: 'Fecha y hora de etiquetado',
      name: 'labelDate',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.labelDate
    },
    {
      title: 'Fecha y hora de primera ubicacion',
      name: 'firsstLocationDate',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.firsstLocationDate
    },
    {
      title: 'Fecha y hora de consolidación',
      name: 'dispatch.dateConsolidated',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch ? element.dispatch.dateConsolidated : ""
    },
    {
      title: 'Fecha y hora de facturación',
      name: 'dispatch.confirmationDate',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch ? element.dispatch.confirmationDate : ""
    },
    {
      title: 'Fecha pre - cancelación',
      name: 'datePreCancelled',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.datePreCancelled
    },
    {
      title: 'Fecha y hora de cancelación',
      name: 'canceledAt',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.canceledAt
    },
    {
      title: 'Fecha y hora de Impresion de etiqueta final',
      name: 'lastUpdated',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.state === STATE_ORDER.PRE_DISPATCH ? element.lastUpdated : '-'
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      sortServer: true,
      class: 'center',
      value: (element: OrderPicking) => element.dispatchTypeCode
    },
    {
      title: 'Medio de pago',
      name: 'paymentMethodName',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.paymentMethodName
    },
    {
      title: 'Modalidad de Despacho',
      name: 'deliveryMethod',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.deliveryMethod
    },
    {
      title: 'Linea',
      name: 'descriptionLine',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.descriptionLine
    },
    {
      title: 'Canal de venta',
      name: 'saleChannel',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.saleChannel? element.dispatch.saleChannel: ""
    },
    {
      title: 'Nª de lote',
      name: 'lotNumber',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.pickingLotDetailList && element.pickingLotDetailList.length == 1?
                                       element.pickingLotDetailList[0].lotNumber: ""
    },
    {
      title: 'Código de viaje',
      name: 'tripId',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.tripId ? element.tripId : ""
    },
    {
      title: 'Código de viaje OTM',
      name: 'tripIdOuter',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.tripIdOuter ? element.tripIdOuter : ""
    },
    {
      title: 'Usuario de Asignación',
      name: 'userAsign',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.assignmentUser ? element.assignmentUser : ""
    },
    {
      title: 'Departamento',
      name: 'department',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.department ? element.dispatch.department : ""
    },
    {
      title: 'Zonas de Despacho',
      name: 'zoneDispatch',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.dispatchZone ? element.dispatch.dispatchZone : ""
    },
    {
      title: 'Fecha máxima de carga',
      name: 'datePicking',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.datePicking ? element.datePicking : ""
    },
    {
      title: 'Ubicación',
      name: 'location',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.containerList[0] ? element.containerList[0].location : ""
    },
    {
      title: 'Entidad final de ruta',
      name: 'lastEntityName',
      type: 'string',
      sortServer: false,
      value: (element: OrderPicking) => element.dispatch.lastEntityName ? element.dispatch.lastEntityName : ""
    },
    {
      title: 'Tiempo transcurrido (horas)',
      name: 'timeElapsed',
      type: 'string',
      sortServer: true,
      value: (element: OrderPicking) => element.dispatch.timeElapsed ? element.dispatch.timeElapsed : ""
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderPicking) => element.groupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderPicking) => element.finalGroupName
    }
  ]
};